import { Grid } from '@mui/material'
import React from 'react'
import AdjustIcon from '@mui/icons-material/Adjust';

export default function () {
    return (
        <div className='p-5 shadow-lg border hover:shadow-xl hover:shadow-black'>

            <Grid container spacing={2} xs={{ justifyContent: "space-between" }}>
                <Grid item xs={6}>
                    <div className='flex cursor-pointer'>
                        <img className='w-[5rem] h-[5rem] object-cover object-top' src='https://i1.wp.com/pt2000.com.vn/wp-content/uploads/2022/05/AD-T10-0CD00-450K.jpg' alt='PT2000' />
                        <div className='ml-5 space-y-2'>
                            <p className='' > Áo đầm thời trang</p>
                            <p className=' opacity-50 text-xs font-semibold'>Size:M</p>
                            <p className=' opacity-50 text-xs font-semibold'>Color: Hồmg</p>

                        </div>
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <p>500,000đ</p>
                </Grid>
                <Grid item xs={4}>
                    {true &&
                        <div>
                            <p>
                                <AdjustIcon sx={{ width: '15px', height: '15px' }} className=' text-green-600 mr-2 text-sm' />
                                <span>
                                    Delivered On March 03
                                </span>

                            </p>
                            <p className=' text-xs'>
                                Your Item Has Been Delivered
                            </p>

                        </div>}
                    {false && <p>
                        <span>
                            Delivered On March 03
                        </span>
                    </p>}
                </Grid>
            </Grid>

        </div>
    )
}
